import { filter } from "@suse-o11y/filter";
import { isPresent } from "@suse-o11y/is-present";
import { z } from "zod";

import { DEFAULT_STEP, type Step } from "../../../components/widget-form/thresholds/settings";
import { partial, tuple } from "../../_decoders";
import { Encoder } from "../../_encoder";

const decoder = z
	.array(
		tuple([
			z.string().optional().catch(undefined),

			z.number().optional().catch(undefined),
		])
			.transform(([color, value]) => partial<Step>({ color, value }))
			.catch(undefined),
	)
	.transform(filter(isPresent))
	.readonly()
	.optional()
	.catch(undefined);

function encoder(steps: undefined | ReadonlyArray<Step>, defaults: ReadonlyArray<Step>): Encoder {
	return Encoder.list(steps, defaults, (threshold) =>
		Encoder.tuple(
			Encoder.primitive(threshold?.color, DEFAULT_STEP.color),
			Encoder.primitive(threshold?.value, DEFAULT_STEP.value),
		),
	);
}

export { decoder, encoder };
